import axios from 'axios';
import { stats } from '@fiverr-private/obs';
import PolicyValidationError from './errors/PolicyValidationError';
import { UploadErrorTypes } from './errors/UploadErrorTypes';
import RemoteActionError from './errors/RemoteActionError';

export default class PolicyHandler {

    constructor(getPolicyUrl, objectName, attachmentName) {
        this.getPolicyUrl = getPolicyUrl;
        this.objectName = objectName;
        this.attachmentName = attachmentName;
    }

    async validatePolicy(file) {
        this.policyData = this.policyData || await this.getPolicy();

        const fileType = file.type;
        const fiverrPolicy = this.policyData.policy.fiverr_policy;

        if (fiverrPolicy.supported_file_types
            && fiverrPolicy.supported_file_types.length
            && fiverrPolicy.supported_file_types.indexOf(fileType) === -1
        ) {
            throw new PolicyValidationError(
                `Unsupported file type: ${fileType}`,
                `supported types are: ${fiverrPolicy.supported_file_types}`,
                PolicyValidationError.types.FILE_TYPE_VIOLATION,
                fiverrPolicy);
        }

        if (fiverrPolicy.unsupported_file_types
            && fiverrPolicy.unsupported_file_types.length
            && fiverrPolicy.unsupported_file_types.indexOf(fileType) !== -1
        ) {
            throw new PolicyValidationError(
                `Unsupported file type: ${fileType}`,
                `unsupported types are: ${fiverrPolicy.unsupported_file_types}`,
                PolicyValidationError.types.FILE_TYPE_VIOLATION,
                fiverrPolicy);
        }

        if (fiverrPolicy.max_file_size
            && fiverrPolicy.max_file_size < file.size
        ) {
            throw new PolicyValidationError(
                `Unsupported file size: ${file.size}`,
                `supported size is: ${fiverrPolicy.max_file_size}`,
                PolicyValidationError.types.FILE_SIZE_VIOLATION,
                fiverrPolicy);
        }

        return this.policyData;
    }

    async getPolicy() {
        try {
            const startTime = Date.now();
            const response = await axios.post(
                this.getPolicyUrl,
                {
                    'object_name': this.objectName,
                    'attachment_name': this.attachmentName
                }
            );

            stats.time(
                `filerr_uploader.${this.objectName}.${this.attachmentName}`,
                's3_policy',
                Date.now() - startTime
            );

            return response.data;
        } catch (error) {
            throw new RemoteActionError(
                error.response?.status || 0,
                error.message,
                UploadErrorTypes.GET_POLICY
            );
        }
    }
}
